import AccountList from 'common/pages/account/AccountList.tsx'

export const AccountListAdmin = (props: any) => <AccountList {...props} mode={props.mode} admin/>